import { getBannerMessage, MessageType } from '../services/bannerMessageHelper';

const APPLICATION_JSON = 'application/json';

function getResponse(response) {
  if (response.status === 200) {
    return response.json();
  } else {
    return response;
  }
}
export function loginWithIpDispatch(payload, csrfToken: string) {
  return fetch('/log-in-with-ip-authentication', {
    method: 'POST',
    headers: {
      'Content-Type': APPLICATION_JSON,
      'X-XSRF-TOKEN': csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      return getResponse(response);
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

export function checkCSRF(csrfToken) {
  return fetch('/check/csrf', {
    method: 'POST',
    headers: {
      'Content-Type': APPLICATION_JSON,
      'X-XSRF-TOKEN': csrfToken,
    },
    body: JSON.stringify({}),
  })
    .then((response) => {
      if (response.status === 403) {
        window.location.reload();
      }
    })
    .catch((error) => {
      console.log('error', error);
      window.location.reload();
    });
}
export function userLoginDispatch(payload: object, csrfToken: string) {
  return fetch('/login', {
    method: 'POST',
    headers: {
      'Content-Type': APPLICATION_JSON,
      'X-XSRF-TOKEN': csrfToken,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

export function userSSODispatch(organizationId) {
  const url = `organizations?namekey=${organizationId}`;
  return fetch(url)
    .then((response) => {
      if (response.status === 404) {
        return {
          error: true,
          message: getBannerMessage('invalidSsoOrganization', MessageType.SsoError),
        };
      } else if (response.status !== 200) {
        return { error: true, message: getBannerMessage('unavailable', MessageType.SsoError) };
      } else {
        return response.json();
      }
    })
    .then((data) => {
      return data;
    });
}

export function forgotPasswordDispatch(payload) {
  return fetch('/resetPasswordInitiation', {
    method: 'POST',
    headers: {
      'Content-Type': APPLICATION_JSON,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      return getResponse(response);
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

export function resetPasswordDispatch(payload) {
  return fetch('/resetPassword', {
    method: 'POST',
    headers: {
      'Content-Type': APPLICATION_JSON,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      return getResponse(response);
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

export function callPiwik(obj) {
  if (window['_paq']) {
    window['_paq'].push(obj);
  }
}

export function acceptTermsOfUse(data, csrfToken) {
  return fetch('/termsofuse/accept', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-XSRF-TOKEN': csrfToken,
    },
    body: data,
  })
    .then((response) => {
      return getResponse(response);
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

export function verifyEmail(data, csrfToken) {
  return fetch('/sru', {
    method: 'POST',
    headers: {
      'Content-Type': APPLICATION_JSON,
      'X-XSRF-TOKEN': csrfToken,
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
      console.error('Error:', error);
    });
}

export async function userVerifyCaptcha(payload) {
  try {
    const response = await fetch('/verify-captcha', {
      method: 'POST',
      headers: {
        'Content-Type': APPLICATION_JSON,
      },
      body: JSON.stringify(payload),
    });
    return await response.json();
  } catch (error) {
    console.error('Error:', error);
  }
}

export async function userRegistration(data, csrfToken) {
  try {
    const response = await fetch('/userRegistration', {
      method: 'POST',
      headers: {
        'Content-Type': APPLICATION_JSON,
        'X-XSRF-TOKEN': csrfToken,
      },
      body: JSON.stringify(data),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error:', error);
  }
}
